const LANGUAGE_STORAGE_KEY = '@ej/language'

export function getLanguageFromStorage(): string | null {
  return localStorage.getItem(LANGUAGE_STORAGE_KEY);
}

export function saveLanguageToStorage(language?: string) {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, language ?? 'pt-BR');
}